"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformBillPaymentsRequest = exports.transformBillPaymentsParsedResponse = exports.transformBillPaymentsListResponse = exports.transformBillPaymentsResponse = void 0;
const Date_1 = require("./Date");
const Error_1 = require("./Error");
const Money_1 = require("./Money");
var PaymentType;
(function (PaymentType) {
    PaymentType["check"] = "Check";
    PaymentType["credit"] = "Credit";
    PaymentType["cash"] = "Cash";
    PaymentType["bankTransfer"] = "Bank Transfer";
    PaymentType["creditCard"] = "Credit Card";
    PaymentType["debit"] = "Debit";
    PaymentType["payPal"] = "PayPal";
    PaymentType["twoCheckout"] = "2Checkout";
    PaymentType["visa"] = "VISA";
    PaymentType["mastercard"] = "MASTERCARD";
    PaymentType["discover"] = "DISCOVER";
    PaymentType["amex"] = "AMEX";
    PaymentType["diners"] = "DINERS";
    PaymentType["jcb"] = "JCB";
    PaymentType["ach"] = "ACH";
    PaymentType["other"] = "Other";
})(PaymentType || (PaymentType = {}));
function transformBillPaymentsResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { bill_payment } = response.response.result;
    return transformBillPaymentsParsedResponse(bill_payment);
}
exports.transformBillPaymentsResponse = transformBillPaymentsResponse;
function transformBillPaymentsListResponse(data, headers, status) {
    const response = JSON.parse(data);
    if ((0, Error_1.isAccountingErrorResponse)(status, response)) {
        return (0, Error_1.transformAccountingErrorResponse)(response);
    }
    const { bill_payments, per_page, total, page, pages } = response.response.result;
    return {
        billPayments: bill_payments.map((payment) => transformBillPaymentsParsedResponse(payment)),
        pages: {
            total,
            size: per_page,
            pages,
            page,
        },
    };
}
exports.transformBillPaymentsListResponse = transformBillPaymentsListResponse;
function transformBillPaymentsParsedResponse(payment) {
    return {
        id: payment.id,
        amount: payment.amount && (0, Money_1.transformMoneyParsedResponse)(payment.amount),
        billId: payment.billid,
        paidDate: payment.paid_date && (0, Date_1.transformDateResponse)(payment.paid_date, Date_1.DateFormat['YYYY-MM-DD']),
        paymentType: payment.payment_type,
        note: payment.note,
        visState: payment.vis_state,
    };
}
exports.transformBillPaymentsParsedResponse = transformBillPaymentsParsedResponse;
function transformBillPaymentsRequest(payment) {
    return JSON.stringify({
        bill_payment: {
            id: payment.id,
            amount: payment.amount && (0, Money_1.transformMoneyParsedRequest)(payment.amount),
            billid: payment.billId,
            paid_date: payment.paidDate && (0, Date_1.transformDateRequest)(payment.paidDate),
            payment_type: payment.paymentType,
            note: payment.note,
            vis_state: payment.visState,
        },
    });
}
exports.transformBillPaymentsRequest = transformBillPaymentsRequest;
//# sourceMappingURL=BillPayments.js.map